//TODO: GROW-2166 when Productizing if fixed win update the InverseHeader in core component and fix imports
//TODO: GROW-2291 Clean up Spring price drop hero experiment
import { usePathname } from 'next/navigation';

import { EventType } from '@/analytics/types';
import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

import HomeHeroShopChiclet from '../HomeHeroShopChiclet';
import HomeHeroWithChicletWrapper from '../HomeHeroWithChicletWrapper';
import HsaFsaIcon from './common/HsaFsaIcon';

const SpringPriceDropHero = () => {
  const path = usePathname();

  const handleCtaClick = () => {
    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop_now',
      action: 'go_to_pdp',
      location: 'hero_module',
      module: 'hero_module',
      path,
    });
  };

  return (
    <HomeHeroWithChicletWrapper>
      <LandingPageHero
        backgroundImage={{
          alt: '',
          srcSet: [
            {
              media: '(max-width: 1023px)',
              src: 'hero/ab/spring_price_hero_mobile',
            },
            {
              media: '(min-width: 1024px)',
              src: 'hero/ab/spring_price_hero_desktop',
            },
          ],
        }}
        backgroundProps={{
          color: 'sandstone-200',
          gradients: [],
        }}
        bottomIcon={<HsaFsaIcon />}
        copy="hero_spring_price_drop_subcopy"
        cta={{
          href: '/product/rings/oura-gen3',
          label: 'shop_oura_ring_gen3',
          onClick: handleCtaClick,
        }}
        data-cy="spring-price-drop-ab-hero"
        title="hero_spring_price_drop_title"
        titleProps={{
          indentation: 'pl-3',
          typographyProps: {
            className:
              'en:lg:whitespace-nowrap mt-[30vh] md:mt-[50vh] lg:mt-auto',
          },
        }}
        textColor="text-sandstone-200"
      />
      <HomeHeroShopChiclet wrap="lg" />
    </HomeHeroWithChicletWrapper>
  );
};

export default SpringPriceDropHero;
